import React, { useState, useEffect } from 'react';
import * as api from '../services/api'
import Loader from '../../components/Loader';
import deleteBin from '../../assets/icons/delete.svg';
import edit from '../../assets/icons/edit.svg';
import styles from './manager.module.css';
import SearchBar from '../../components/SearchBar';
import PrevAndNextBtn from '../../components/PrevAndNextBtn';
import CustomizedModal from '../../components/modal/CustomizedModal';
import { useNavigate } from "react-router-dom";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Checkbox, MenuItem, Select } from '@mui/material';

function ManageTable({ list, handleEdit, handleDelete, loading, handleCheckboxChange, handleLink }) {
    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }
    return (
        <TableContainer component={Paper} elevation={0}>
            <Table aria-label="hospital table">
                <TableHead>
                    <TableRow sx={{ background: '#c8ebea' }}>
                        <TableCell
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '40%', paddingLeft: '2.5pc' }}
                        >
                            ชื่อ
                        </TableCell>
                        <TableCell
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '10%' }}
                            align="center"
                        >
                            ลิ้งค์บทความ
                        </TableCell>
                        <TableCell
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '10%' }}
                            align="center"
                        >
                            แบนเนอร์
                        </TableCell>
                        <TableCell
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '10%' }}
                            align="center"
                        >
                            บทความแนะนำ
                        </TableCell>
                        <TableCell
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '10%' }}
                            align="center"
                        >
                            วันที่อัพเดต
                        </TableCell>
                        <TableCell
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '10%' }}
                            align="center"
                        >
                            การเข้าชม
                        </TableCell>
                        <TableCell
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '10%' }}
                            align="center"
                        >
                            จัดการ
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.length === 0 ? (
                        <TableRow>
                            <TableCell
                                className={styles.head2Text}
                                colSpan={5}
                                align="center"
                                style={{ borderBottom: '1px solid transparent', paddingTop: '5pc' }}
                            >
                                {loading ? 'กำลังโหลดข้อมูล...' : 'ไม่มีข้อมูล'}
                            </TableCell>
                        </TableRow>
                    ) : (
                        list.map((each) => (
                            <TableRow key={each.new_code} sx={{ borderBottom: '1px solid transparent', '&:hover': { backgroundColor: '#fafafa' } }}>
                                <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent', padding: '10px 8px 10px 40px' }} >
                                    {each.new_title}
                                </TableCell>
                                <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent', padding: '10px 0px', color: '#6187e9', textDecoration: 'underline', cursor: "pointer" }} align="center"
                                    onClick={() => handleLink(each.new_code)}
                                >
                                    ลิ้งค์
                                </TableCell>
                                <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent', padding: '10px 0px' }} align="center">
                                    <Checkbox
                                        checked={each.banner_status === "Y"}
                                        onChange={(e) => handleCheckboxChange(each.new_code, 'banner_status', e.target.checked)}
                                        inputProps={{ 'aria-label': 'Checkbox for banner' }}
                                    />
                                </TableCell>
                                <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent', padding: '10px 0px' }} align="center">
                                    <Checkbox
                                        checked={each.favorite_status === "Y"}
                                        onChange={(e) => handleCheckboxChange(each.new_code, 'favorite_status', e.target.checked)}
                                        inputProps={{ 'aria-label': 'Checkbox for recommend' }}
                                    />
                                </TableCell>
                                <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent' }} align="center">
                                    {convertDate(each.updated_date || each.created_date)}
                                </TableCell>
                                <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent' }} align="center">
                                    {each.views_total}
                                </TableCell>
                                <TableCell style={{ borderBottom: '1px solid transparent', padding: '12px 8px 8px 8px' }} align="center">
                                    <img src={edit} alt="Edit" onClick={() => handleEdit(each)} className={styles.modifyIcon} />
                                    <img src={deleteBin} alt="Delete" onClick={() => handleDelete(each.new_code, each.new_title)} className={styles.modifyIcon} />
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

function NewsManager() {
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredList, setFilteredList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toDelete, setToDelete] = useState({ new_code: null, new_title: null }); // State for the item to delete
    const [showDeleteModal, setShowDeleteModal] = useState(false); // State for modal visibility
    const navigate = useNavigate();

    useEffect(() => {
        fetchNewsData(currentPage, null, null);
    }, []);

    const fetchNewsData = async (page, search) => {
        setLoading(true);
        const res = await api.findNews(page, search, null);
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                const detail = res['data']['data'];
                setFilteredList(detail);
                setTotalPage(res['data']['pagging']['totalPage'])
            } else if ("Not found data." === res['data']['message']) {
                setFilteredList([]);
                setTotalPage(1);
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    };

    const handleLink = (code) => {
        window.open(`/showNews?code=${code}`);
    }

    const handleSearch = () => {
        setCurrentPage(1);
        fetchNewsData(1, searchQuery)
    };

    const handleEdit = (detail) => {
        navigate('/newsEdit', { state: { detail } });
    };

    const handleAdd = () => {
        navigate('/newsAdd');
    };

    const handleDeleteClick = (new_code, new_title) => {
        setToDelete({ new_code, new_title });
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        setLoading(true);
        const res = await api.deleteNews(toDelete.new_code);
        setLoading(false);
        setShowDeleteModal(false);
        if (res) {
            if (res['data']['code'] === 200) {
                if (
                    filteredList.length === 1 &&
                    currentPage === totalPage &&
                    currentPage > 1
                ) {
                    setCurrentPage(currentPage - 1);
                    await fetchNewsData(currentPage - 1, searchQuery);
                } else {
                    await fetchNewsData(currentPage, searchQuery);
                }
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    };

    const handleCloseModal = () => {
        setShowDeleteModal(false);
    };

    const handleNext = async () => {
        if (currentPage < totalPage) {
            const nextPage = currentPage + 1;
            setCurrentPage(nextPage);
            await fetchNewsData(nextPage, searchQuery);
        }
    };

    const handlePrevious = async () => {
        if (currentPage > 1) {
            const previousPage = currentPage - 1;
            setCurrentPage(previousPage);
            await fetchNewsData(previousPage, searchQuery);
        }
    };

    const handleCheckboxChange = async (new_code, field, value) => {
        // Update state locally
        const updatedList = filteredList.map((each) =>
            each.new_code === new_code ? { ...each, [field]: value ? "Y" : "N" } : each
        );
        setFilteredList(updatedList);
        try {
            const res = await api.findNewsDetail(new_code);
            let detail = {};
            if (res) {
                if (res['data']['code'] === 200) {
                    detail = res['data']['data'];
                } else {
                    //alert(res['data']['message']);
                }
            } else {
                alert("ไม่ตอบสนอง");
            }
            const updatedDetail = { ...detail, [field]: value ? "Y" : "N" };
            const resp = await api.updateNews(updatedDetail);
            if (resp) {
                if (resp['data']['code'] !== 200) {
                    alert(resp['data']['message']);
                }
            } else {
                alert("ไม่ตอบสนอง");
            }
        } catch (error) {
            console.error(`Failed to update ${field} for new_code: ${new_code}`, error);
        }
    };

    return (
        <>
            <Loader loading={loading} />
            {showDeleteModal && (
                <CustomizedModal
                    onClose={handleCloseModal}
                    apiCall={confirmDelete}
                    confirmMessage={`ต้องการลบ "${toDelete.new_title}" หรือไม่?`}
                    confirmButtonText={`ยืนยัน`}
                />
            )}
            <Box className={styles.head1Text}>จัดการข่าวสารสุขภาพ</Box>
            <Box className={styles.bodyText}>จัดการข่าวสารสุขภาพ และประชาสัมพันธ์จากระบบ</Box>
            <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Box className={styles.head2Text}>ค้นหาข่าวสาร</Box>
                <SearchBar
                    label="ค้นหาด้วยชื่อ"
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    handleSearch={handleSearch}
                />

                {/* Add news button */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 1 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAdd}
                        sx={{ padding: 1, borderRadius: 1.5, marginRight: 1 }}
                    >
                        <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 35px' }}>เพิ่มใหม่</p>
                    </Button>
                </Box>

                {/* Select type of news */}
                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 1 }}>
                    <Select
                        size="small"
                        sx={{ ...SelectCss, minWidth: 120 }}
                        value={type || "null"}
                        onChange={(e) => { setType(e.target.value) }}
                    >
                        <MenuItem value="null" disabled>
                            เลือกประเภท
                        </MenuItem>
                    </Select>
                </Box> */}
                <Box sx={{  marginTop: 2, flexGrow: 1, border: '1px solid #aeb4dd', borderRadius: 1, backgroundColor: 'white',position: 'relative',overflow: 'auto' }}>
                    <ManageTable
                        list={filteredList}
                        handleEdit={handleEdit}
                        handleDelete={handleDeleteClick}
                        loading={loading}
                        handleCheckboxChange={handleCheckboxChange}
                        handleLink={handleLink}
                    />
                    <Box sx={{ marginRight: 2, marginBottom: 2 }}>
                        <PrevAndNextBtn
                            handlePrevious={handlePrevious}
                            handleNext={handleNext}
                            currentPage={currentPage}
                            totalPage={totalPage}
                        />
                    </Box>
                </Box>
            </Box>
        </>
    );
}
export default NewsManager;

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    color: '#478F96',
    fontWeight: 800,
    fontSize: '12px',
    borderRadius: 1.5,
}